/**
 * A user's own notification feed — an app or layer shared with them, being
 * added to a group, or their own role being changed. Written by the server
 * at the moment one of those happens (see `services.notify` on the
 * backend); this is a read/ack surface only, nothing here creates one.
 */

import { api } from './apiClient';

export type NotificationKind = 'module_shared' | 'layer_shared' | 'group_added' | 'role_changed';

export interface AppNotification {
  id: string;
  kind: NotificationKind;
  title: string;
  body?: string;
  read: boolean;
  createdAt: string;
}

interface ApiNotificationList {
  items: AppNotification[];
  unreadCount: number;
}

export const notificationService = {
  async list(): Promise<ApiNotificationList> {
    return api.get<ApiNotificationList>('/notifications');
  },

  async markRead(id: string): Promise<void> {
    await api.post<AppNotification>(`/notifications/${encodeURIComponent(id)}/read`);
  },

  async markAllRead(): Promise<void> {
    await api.post<void>('/notifications/read-all');
  },
};
